module.exports = __webpack_public_path__ + "static/media/test.dcdb6a81.geojson";